import weui from "weui.js";
import base from "@/api/base";
export default {
    data() {
        return {
            baseHttps: base.https,
            baseHttp: base.http,
            baseUrl: base.url + "/",
        }
    },
    checkIsWeixinJSBroadside(payInfo) {
     
        
        if (typeof WeixinJSBridge == "undefined"){
            if( document.addEventListener ){
                document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
            }else if (document.attachEvent){
                document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
            }
        }else{
            this.onBridgeReady(payInfo);
        }
    },
    checkIsWeixinJSBridgeLkl(payInfo) {

        if (typeof WeixinJSBridge == "undefined"){
            if( document.addEventListener ){
                document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
            }else if (document.attachEvent){
                document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
            }
        }else{
            this.onBridgeReadyLkl(payInfo);
        }
    },
    onBridgeReady(payInfo){
        window.WeixinJSBridge.invoke(
            'getBrandWCPayRequest', {
                'appId': payInfo.appId, // 公众号名称，由商户传入
                'timeStamp': payInfo.timeStamp, // 时间戳，自1970年以来的秒数
                'nonceStr': payInfo.nonceStr, // 随机串
                'package': payInfo.package,
                'signType': payInfo.signType, // 微信签名方式
                'paySign': payInfo.paySign // 微信签名
            },
            res => {

                
                // window.location.href = "components/weChat/parkingLot/roadside"
                if (res.err_msg === 'get_brand_wcpay_request:ok') {
                    // 使用以上方式判断前端返回,微信团队郑重提示：
                    // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                    let url = this.baseUrl.substr (0,5)
                    if (url=="https") {
                        window.location.href = this.baseHttps+"/weChat/parkingLot/roadside"
                    }else{
                        window.location.href = this.baseHttp+"/weChat/parkingLot/roadside"
                    }
                  
                }else{
                    weui.dialog({
                        title: '提示',
                        content: '支付失败',
                        className: 'custom-classname',
                        buttons: [{
                            label: '确定',
                            type: 'primary',
                        }]
                    });
                }
            })
    },
    onBridgeReadyLkl(payInfo){
        console.log('onBridgeReadyLkl-------------------'),
      
       
        window.WeixinJSBridge.invoke(
            'getBrandWCPayRequest', {
                'appId': payInfo.app_id, // 公众号名称，由商户传入
                'timeStamp': payInfo.time_stamp, // 时间戳，自1970年以来的秒数
                'nonceStr': payInfo.nonce_str, // 随机串
                'package': payInfo.package,
                'signType': payInfo.sign_type, // 微信签名方式
                'paySign': payInfo.pay_sign // 微信签名
            },
            console.log('app_id'+app_id),
            console.log('pay_sign'+pay_sign),
            console.log('res.err_msg'+res.err_msg),
            res => {
                // window.location.href = "components/weChat/parkingLot/roadside"
                if (res.err_msg === 'get_brand_wcpay_request:ok') {
                    // 使用以上方式判断前端返回,微信团队郑重提示：
                    // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                    window.location.href = this.baseHttps+"/weChat/parkingLot/roadside"
                }else{
                    weui.dialog({
                        title: '提示',
                        content: '支付失败',
                        className: 'custom-classname',
                        buttons: [{
                            label: '确定',
                            type: 'primary',
                        }]
                    });
                }
            })
    },
}





